module.exports = "<div *ngIf=\"!isLoading\" echarts [initOpts]=\"initOpts\" [options]=\"chartOption\" (chartInit)=\"onChartInit($event)\"\n    [style.width.px]=\"initOpts.width\" [style.height.px]=\"initOpts.height\"></div>\n<div *ngIf=\"isLoading\" class=\"missing-chart\">\n    <i class=\"fa fa-spinner fa-spin fa-3x fa-fw\"></i>\n    <span class=\"sr-only\">Loading...</span>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/components/chart/comparative-bar-chart/comparative-bar-chart.component.html
// module id = ./src/app/shared/components/chart/comparative-bar-chart/comparative-bar-chart.component.html
// module chunks = main